import React from 'react';
import { parseNumber } from 'utils/parser';
import { getUomTypesAbbreviations } from '../DailyValueConstants';
import { useGetBasicUomEnum } from 'hooks';

const LinearVitaminLabel = ({
  ingredient,
  labelBold = false,
  isEnd = false,
}) => {
  const { basicUomProperties } = useGetBasicUomEnum();

  const {
    nutritionName,
    quantity,
    quantityUom,
    dailyValueIntakePercent,
    hightLightText,
  } = ingredient ?? {};

  const gram = `${parseNumber(quantity)} ${getUomTypesAbbreviations(
    basicUomProperties,
    quantityUom
  )}`;
  const percent = parseNumber(dailyValueIntakePercent);

  const styles = {
    indent: {
      backgroundColor: hightLightText,
    },
  };

  return (
    <span style={styles.indent}>
      <span>
        <span style={{ fontWeight: labelBold ? 'bold' : '' }}>
          {nutritionName}
        </span>
        <span style={{ paddingLeft: '2px' }}>{gram}</span>{' '}
        {percent === 0 || percent > 0 ? `(${percent}% DV)` : `(0% DV)`}
        {isEnd ? '.' : ','}
      </span>
    </span>
  );
};

export default LinearVitaminLabel;
